import React, { useState } from "react";
import "./FAQ.css";
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={toggleAnswer}>
        {question}
        <span>{isOpen ? "-" : "+"}</span>
      </div>
      {isOpen && <div className="faq-answer"><p>{answer}</p></div>}
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      question: "How does it work?",
      answer:
        "It's easy! You just have to pick an item you like on our website, select a start and an end date, and confirm your order. You can decide to pick up your order at our store in Bengaluru  or to let us deliver it to your address."
    },
    {
      question: "How long can I keep the items?",
      answer:
        "You can wear the items until the rental's last day. The items have to be sent back to us within the last day of the rental or the next workday."
    },
    {
      question: "Do I have to clean the items at the end of each rental?",
      answer:
        "It's not necessary as we include the cleaning process in our service. All our items will be cleaned professionally after each rental."
    },
    {
      question: "What is the purchase option?",
      answer:
        "The purchase option is an extension of the rental that covers the item's value and allows you to become the owner of one or more items at the end of the rental period."
    },
    {
      question: "How can I choose the right size for me?",
      answer:
        "You can easily spot the best size for you by referring to our Size Guide that provides a conversion table to all major country size systems."
    },
    {
      question: "Are alterations possible?",
      answer:
        "Yes! Feel free to come to our store in BTM 2nd stage,Bangalore  for semi-permanent or permanent alterations."
    },
    {
      question: "Which payment methods do you accept?",
      answer:
        "We accept all major credit cards, PayPal, Apple Pay, Google Pay, and Samsung Pay."
    },
    {
      question: "How long does an order take to arrive?",
      answer:
        "Orders are usually dispatched between 1-3 days from the date of the order being placed. Delivery time varies depending on the location."
    },
    {
      question: "How can I track my order?",
      answer:
        "Once you place your order online, you will be able to see the details of the purchase, follow its preparation, and see shipping updates in the My Account area."
    },
    {
      question: "How to return my items?",
      answer:
        "Returns are free for rentals. For purchases, we do not currently offer free returns. You will need to cover the cost of returning items yourself."
    }
  ];

  return (
    <>
<div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>Frequently Asked Questions</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>Frequently Asked Questions</h6></div>
                        </div>
                    </div>
                </div>

            </div>
    <div className="faq-section">
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
    <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
    
    </>
  );
};

export default FAQ;
